import { render, staticRenderFns } from "./MarketplaceItem.vue?vue&type=template&id=584886cc&scoped=true&"
import script from "./MarketplaceItem.vue?vue&type=script&lang=js&"
export * from "./MarketplaceItem.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceItem.vue?vue&type=style&index=0&id=584886cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584886cc",
  null
  
)

export default component.exports